module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header_2_m-bf970711be51e24daa9b39b0b140a1bd.jpg";